import { environment } from '../../../../../environments/environment';

export const DETAILS = '/details';
export const DASHBOARD = (id: number) => `/dashboard/${id}`;
export const DETAILS_WITH_ID = (id: number) => `/details/${id}`;
export const MEMBERSHIPS_PATH = '/memberships';
export const MEMBERSHIPS_LANDING_PAGE = (orgnaizationName: string, membershipName: string, memberhipsId: number) =>
	`${environment.CONSUMER_SITE_URL}/${encodeURIComponent(
		orgnaizationName.replace(/ /g, '-')
	)}/memberships/${encodeURIComponent(membershipName.replace(/ /g, '-'))}/${memberhipsId}`;
